<a
    *ngIf="!isset"
    [href]="loginUrl"
    class="message--module-inactive message--module-inactive--comanage"
    (click)="activeModal.dismiss()">
    <strong>You are not logged in with CoManage.</strong>
    <small>Click to connect your account.</small>
</a>
